import React from 'react';
import {
  Box, Typography,
} from '@mui/material';

interface IField {
  label: string;
  value: string;
}
function AssociateDetailHeaderFieldPage(props: IField) {

  return (
    <Box className='AssociateDetailHeaderFieldsBox'>
      <Typography component="div" align="left">
        <span className='AssociateDetailHeaderFieldsLabel'>{props.label}</span>
      </Typography>
      <Typography component="div" align="left">
        <span className='AssociateDetailHeaderFieldsText'>{props.value}</span>
      </Typography>
    </Box>
  )
}

export default React.memo(AssociateDetailHeaderFieldPage);
